import { Colors } from 'styles';

import styled, { css } from 'styled-components';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

const baseCss = css`
  font-size: 1.3em;
  margin: 0 0.25em;
  cursor: pointer;
`;

const disabledCss = css`
  cursor: not-allowed;
  color: ${Colors.gray5};
`;

const defaultCss = css`
  cursor: pointer;
  color: ${Colors.gray7};

  &:hover,
  &:focus {
    outline: none;
    color: ${(props: { hovercolor?: string }) => props.hovercolor ?? Colors.mainBlueHover};
  }
`;

type RightDrawerHeaderIconProps = {
  disabled?: boolean;
  as: typeof ExpandLessIcon | typeof ExpandMoreIcon;
  hovercolor?: string;
};

export const RightDrawerHeaderIcon = styled.span.attrs({
  role: 'button',
})<RightDrawerHeaderIconProps>`
  ${baseCss}
  ${(props) => (props.disabled ? disabledCss : defaultCss)}
  /* slight adjustment for the expand/contract icon since it's smaller than the others */
  ${(props) =>
    (props.as === ExpandLessIcon || props.as === ExpandMoreIcon) &&
    css`
      font-size: 2em;
      margin: 0 1px;
    `}
`;
